"use strict";
exports.__esModule = true;
var fp_1 = require("lodash/fp");
var fp_2 = require("lodash/fp");
var api_1 = require("../api");
var bridge_1 = require("./bridge");
var cache_1 = require("../../../cache");
var mock_data_1 = require("./mock-data");
var cached_1 = require("../api/cached");
function mockChainAPI(config) {
    var mockedMethods = (0, mock_data_1.getMockedMethods)();
    var api = new Proxy({ config: config }, {
        get: function (_, propKey) {
            if (propKey in api) {
                return api[propKey];
            }
            if (propKey === "then") {
                return undefined;
            }
            var method = propKey.toString();
            var mocks = mockedMethods.filter(function (mock) { return mock.method === method; });
            if (mocks.length === 0) {
                throw new Error("no mock found for api method: ".concat(method));
            }
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var definedArgs = removeUndefineds(args);
                var mock = mocks.find(function (_a) {
                    var params = _a.params;
                    return (0, fp_1.isEqual)(definedArgs)(params);
                });
                if (mock === undefined) {
                    var argsJson = JSON.stringify(args);
                    throw new Error("no mock found for api method ".concat(method, " with args ").concat(argsJson));
                }
                return Promise.resolve(mock.answer);
            };
        }
    });
    return api;
}
function removeUndefineds(input) {
    return (0, fp_1.isObject)(input)
        ? (0, fp_1.isArray)(input)
            ? input.map(removeUndefineds)
            : (0, fp_1.flow)((0, fp_2.omitBy)(fp_2.isUndefined), (0, fp_2.mapValues)(removeUndefineds))(input)
        : input;
}
// Bridge with this api will log all api calls to a file.
// The calls data can be copied to mock-data.ts from the file.
/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
function createMockDataForAPI() {
    var apiGetter = (0, cache_1.makeLRUCache)(function (config) {
        return Promise.resolve((0, api_1.cached)((0, api_1.queued)((0, api_1.logged)((0, api_1.getChainAPI)(config), "/tmp/log"), 100)));
    }, function (config) { return config.endpoint; }, (0, cached_1.minutes)(1000));
    return {
        getAPI: apiGetter,
        getQueuedAPI: apiGetter,
        getQueuedAndCachedAPI: apiGetter
    };
}
function getMockedAPIs() {
    var mockedAPI = mockChainAPI({ cluster: "mock" });
    return {
        getAPI: function (_) { return Promise.resolve(mockedAPI); },
        getQueuedAPI: function (_) { return Promise.resolve(mockedAPI); },
        getQueuedAndCachedAPI: function (_) { return Promise.resolve(mockedAPI); }
    };
}
//export default makeBridges(createMockDataForAPI());
exports["default"] = (0, bridge_1.makeBridges)(getMockedAPIs());
//# sourceMappingURL=mock.js.map